import Community from '../Community/Community.container';
import { Header, Wrapper } from './ContentBrowse.style';

export type ContentBrowseProps = {};

export function ContentBrowse(props: ContentBrowseProps) {
  const {} = props;

  return (
    <Wrapper
      className='ContentBrowse-wrapper'
      data-testid='ContentBrowse-wrapper'
      $grainIntensity={0.3}
    >
      <Header>Browse Ideas</Header>
      <Community />
    </Wrapper>
  );
}

export default ContentBrowse;
